import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import DashboardLayout from "../layouts/DashboardLayout";
import { authService } from "../authorization/authService";
// FA6 (default for modern browsers; uses var() for icon content)
import "@fortawesome/fontawesome-free/css/all.min.css";
// FA6-only icon name aliases mapped to FA5 unicode values (fallback for old browsers)
import "../../styles/base/typography/font-awesome/fa6-fallback.css";

const App: React.FC = () => {
  // Lazy-load FA5 CSS after initial render so it doesn't block paint.
  // FA5 is still needed as a fallback: several SCSS modules reference the
  // "Font Awesome 5 Free" font-family directly, and older browsers that
  // don't support CSS custom properties (var()) need FA5's static content values.
  useEffect(() => {
    import("../../styles/base/typography/font-awesome/all.min.css");
  }, []);
  const navigate = useNavigate();

  // Handle Logout
  const handleLogout = async () => {
    try {
      await authService.signOut();
      navigate("/"); // Redirect to login page
    } catch (error) {
      console.error("Logout failed:", error);
    }
  };

  return <DashboardLayout onLogout={handleLogout} />;
};

export default App;
